import { Tabs as LibTabs } from "@mui/material";

import { isMobile } from "@hooks/layout";

import styled from "styled-components";

export const Tabs = styled(LibTabs)`
  &.MuiTabs-root {
    min-height: fit-content;
    border-bottom: 1px solid #a48b7873;
    overflow: unset;
    justify-content: center;

    & > div {
      overflow: unset !important;
    }

    .MuiTabs-scroller {
      flex: unset;
    }

    .MuiTabs-flexContainer {
      justify-content: space-between;
    }

    .MuiTab-root {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      min-width: fit-content;

      .MuiTab-iconWrapper {
        margin: 0;
      }

      svg {
        width: 20px;
        height: 20px;

        path {
          fill: #cbbaac;
        }
      }

      &[aria-selected="true"] {
        svg path {
          fill: #f5dfc4;
        }
      }
    }

    .album,
    .filter {
      transform: translateY(-1px);
    }
  }

  & button {
    width: 33.33%;
    max-width: 33.33%;
    color: #cbbaac;
    font-size: 0.75rem;
    padding: 10px 0;
    height: fit-content;
    min-height: fit-content;
  }

  && .Mui-selected {
    color: #f5dfc4;
  }

  && {
    .MuiTabs-indicator {
      height: 1px;
      background-color: #f5dfc4;
      transform: translateY(100%);
    }
  }

  ${isMobile} {
    .track {
      transform: translateY(-1px);
    }
  }
`;
